function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import { validUsername } from '@/utils/validate';
import '@/assets/js/canvas-nest.min.js';
import { getLoginPicApi } from '@/api/user';
import { accountDetectionApi, frontDomainApi, getSystemColorApi, getMerchantRegUrlApi, sendSigningCodeApi, getApplyQryApi, sendQueryCodeApi } from '@/api/authInformation';
import VerifitionVerify from './verifition/Verify.vue';
export default {
  name: 'Login',
  data: function data() {
    var validateUsername = function validateUsername(rule, value, callback) {
      if (!validUsername(value)) {
        callback(new Error('Please enter the correct user name'));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (value.length < 6 || value.length > 12) {
        callback(new Error('密码位数为6-12位'));
      } else {
        callback();
      }
    };
    return {
      showCaptchatImg: false,
      captchatImg: '',
      leftLogo: '',
      loginLogo: '',
      backgroundImages: '',
      backgroundImageMo: require('@/assets/imgs/bg.jpg'),
      fullWidth: document.body.clientWidth,
      swiperOption: {
        pagination: {
          el: '.pagination'
        },
        autoplay: {
          enabled: true,
          disableOnInteraction: false,
          delay: 3000
        }
      },
      loginForm: {
        account: '18292417675',
        pwd: '000000',
        captchaVO: {}
      },
      loginRules: {
        account: [{
          required: true,
          trigger: 'blur',
          message: '请输入用户名'
        }],
        pwd: [{
          required: true,
          trigger: 'blur',
          message: '请输入密码'
        }],
        code: [{
          required: true,
          message: '请输入正确的验证码',
          trigger: 'blur'
        }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      disabled: false,
      errorsNumber: 0,
      //账号密码输入错误次数
      // 申请入驻相关
      applyDialogVisible: false,
      applyLoading: false,
      applyForm: {
        nameOrCompany: '',
        phone: '',
        code: ''
      },
      applyRules: {
        nameOrCompany: [{
          required: true,
          message: '请输入个人或公司名称',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '手机号格式不正确',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }, {
          pattern: /^\d{4,6}$/,
          message: '验证码格式不正确',
          trigger: 'blur'
        }]
      },
      codeCountdown: 0,
      codeLoading: false,
      codeTimer: null,
      // 查询入驻相关
      queryDialogVisible: false,
      queryLoading: false,
      queryForm: {
        phone: '',
        code: ''
      },
      queryRules: {
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '手机号格式不正确',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }, {
          pattern: /^\d{4,6}$/,
          message: '验证码格式不正确',
          trigger: 'blur'
        }]
      },
      queryCodeCountdown: 0,
      queryCodeLoading: false,
      queryCodeTimer: null,
      // 查询结果跳转弹窗
      queryResultDialogVisible: false,
      queryResultPageUrl: ''
    };
  },
  components: {
    VerifitionVerify: VerifitionVerify
  },
  watch: {
    fullWidth: function fullWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        var that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          that.timer = false;
        }, 400);
      }
    },
    $route: {
      handler: function handler(route) {
        var query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {
    var _this = this;
    document.onkeydown = function (e) {
      if (_this.$route.path.indexOf('login') !== -1) {
        var key = window.event.keyCode;
        if (key === 13) {
          _this.handleLogin();
        }
      }
    };
    window.addEventListener('resize', this.handleResize);
  },
  mounted: function mounted() {
    var _this2 = this;
    this.getInfo();
    this.onBlurAccount();
    this.$nextTick(function () {
      if (_this2.screenWidth < 768) {
        document.getElementsByTagName('canvas')[0].removeAttribute('class', 'index_bg');
      } else {
        document.getElementsByTagName('canvas')[0].className = 'index_bg';
      }
    });
    if (this.loginForm.account === '') {
      this.$refs.account.focus();
    } else if (this.loginForm.pwd === '') {
      this.$refs.pwd.focus();
    }
  },
  beforeCreate: function beforeCreate() {
    if (this.fullWidth < 768) {
      document.getElementsByTagName('canvas')[0].removeAttribute('class', 'index_bg');
    } else {
      document.getElementsByTagName('canvas')[0].className = 'index_bg';
    }
  },
  destroyed: function destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    document.getElementsByTagName('canvas')[0].removeAttribute('class', 'index_bg');
    if (this.codeTimer) {
      clearInterval(this.codeTimer);
      this.codeTimer = null;
    }
    if (this.queryCodeTimer) {
      clearInterval(this.queryCodeTimer);
      this.queryCodeTimer = null;
    }
  },
  methods: {
    // 获取移动端域名
    getUrl: function getUrl() {
      var _this3 = this;
      frontDomainApi().then(function (res) {
        _this3.$store.commit('settings/SET_FrontDomain', res);
      });
    },
    //获取移动端主题色
    getMobileThemeColor: function getMobileThemeColor() {
      var _this4 = this;
      getSystemColorApi().then(function (res) {
        _this4.$store.commit('settings/SET_mobileThemeColor', res);
      });
    },
    //校验成功之后
    handlerOnVerSuccess: function handlerOnVerSuccess(repData) {
      this.loginForm.captchaVO = repData;
      this.success();
    },
    //账号失去焦点
    onBlurAccount: function () {
      var _onBlurAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return accountDetectionApi({
                account: this.loginForm.account
              });
            case 1:
              this.errorsNumber = _context.v;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onBlurAccount() {
        return _onBlurAccount.apply(this, arguments);
      }
      return onBlurAccount;
    }(),
    handleResize: function handleResize(event) {
      this.fullWidth = document.body.clientWidth;
      if (this.fullWidth < 768) {
        document.getElementsByTagName('canvas')[0].removeAttribute('class', 'index_bg');
      } else {
        document.getElementsByTagName('canvas')[0].className = 'index_bg';
      }
    },
    getInfo: function getInfo() {
      var _this5 = this;
      getLoginPicApi().then(function (res) {
        _this5.leftLogo = res.leftLogo;
        _this5.loginLogo = res.loginLogo;
        _this5.backgroundImages = res.backgroundImage;
        localStorage.setItem('platSiteName', res.siteName);
      });
    },
    checkCapslock: function checkCapslock(e) {
      var key = e.key;
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z';
    },
    showPwd: function showPwd() {
      var _this6 = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this6.$refs.pwd.focus();
      });
    },
    handleLogin: function handleLogin() {
      var _this7 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          if (Number(_this7.errorsNumber) > 2) {
            _this7.$refs.verifyRef.show();
          } else {
            _this7.success(null);
          }
        } else {
          return false;
        }
      });
    },
    success: function success(params) {
      var _this8 = this;
      this.loginForm.captcha = this.$store.state.user.captcha;
      var loading = this.$loading({
        lock: true,
        text: '正在登录中...'
      });
      this.$store.dispatch('user/login', this.loginForm).then(function () {
        _this8.$store.dispatch('user/getMenus', {
          that: _this8
        }).then(function (res) {
          _this8.redirectWithReload(_this8.redirect || '/dashboard', _this8.otherQuery);
        });
        _this8.getUrl();
        _this8.getMobileThemeColor();
        loading.close();
        _this8.disabled = true;
      }).catch(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(err) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return _this8.onBlurAccount();
              case 1:
                loading.close();
                _this8.disabled = false;
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    redirectWithReload: function redirectWithReload(path) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var searchParams = new URLSearchParams(query).toString();
      var targetPath = searchParams ? "".concat(path, "?").concat(searchParams) : path;
      var currentSearch = new URLSearchParams(window.location.search);
      currentSearch.set('_loginReload', Date.now().toString());
      var targetUrl = "".concat(window.location.origin).concat(window.location.pathname, "?").concat(currentSearch.toString(), "#").concat(targetPath);
      window.location.replace(targetUrl);
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    // 显示申请入驻弹窗
    showApplyDialog: function showApplyDialog() {
      var _this9 = this;
      this.applyDialogVisible = true;
      this.applyForm = {
        nameOrCompany: '',
        phone: '',
        code: ''
      };
      this.codeCountdown = 0;
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
      this.$nextTick(function () {
        _this9.$refs.applyFormRef && _this9.$refs.applyFormRef.clearValidate();
      });
    },
    // 发送验证码
    sendCode: function sendCode() {
      var _this0 = this;
      // 先验证手机号
      this.$refs.applyFormRef.validateField('phone', function (errorMessage) {
        if (errorMessage) {
          return;
        }
        _this0.codeLoading = true;
        sendSigningCodeApi({
          phone: _this0.applyForm.phone
        }).then(function () {
          _this0.$message.success('验证码发送成功');
          _this0.codeCountdown = 60;
          _this0.codeTimer = setInterval(function () {
            _this0.codeCountdown--;
            if (_this0.codeCountdown <= 0) {
              clearInterval(_this0.codeTimer);
              _this0.codeTimer = null;
            }
          }, 1000);
          _this0.codeLoading = false;
        }).catch(function (err) {
          _this0.codeLoading = false;
          _this0.$message.error(err.message || '验证码发送失败，请稍后重试');
        });
      });
    },
    // 提交申请入驻
    submitApply: function submitApply() {
      var _this1 = this;
      this.$refs.applyFormRef.validate(function (valid) {
        if (valid) {
          _this1.applyLoading = true;
          getMerchantRegUrlApi(_this1.applyForm).then(function (res) {
            _this1.applyLoading = false;
            _this1.applyDialogVisible = false;
            if (res) {
              // 跳转到返回的链接
              window.open(res, '_blank');
            } else {
              _this1.$message.error('获取入驻链接失败');
            }
          }).catch(function (err) {
            _this1.applyLoading = false;
            _this1.$message.error(err.message || '申请失败，请稍后重试');
          });
        }
      });
    },
    // 显示查询入驻弹窗
    showQueryDialog: function showQueryDialog() {
      var _this10 = this;
      this.queryDialogVisible = true;
      this.queryForm = {
        phone: '',
        code: ''
      };
      this.queryCodeCountdown = 0;
      if (this.queryCodeTimer) {
        clearInterval(this.queryCodeTimer);
        this.queryCodeTimer = null;
      }
      this.$nextTick(function () {
        _this10.$refs.queryFormRef && _this10.$refs.queryFormRef.clearValidate();
      });
    },
    // 发送查询验证码
    sendQueryCode: function sendQueryCode() {
      var _this11 = this;
      // 先验证手机号
      this.$refs.queryFormRef.validateField('phone', function (errorMessage) {
        if (errorMessage) {
          return;
        }
        _this11.queryCodeLoading = true;
        sendQueryCodeApi({
          phone: _this11.queryForm.phone
        }).then(function () {
          _this11.$message.success('验证码发送成功');
          _this11.queryCodeCountdown = 60;
          _this11.queryCodeTimer = setInterval(function () {
            _this11.queryCodeCountdown--;
            if (_this11.queryCodeCountdown <= 0) {
              clearInterval(_this11.queryCodeTimer);
              _this11.queryCodeTimer = null;
            }
          }, 1000);
          _this11.queryCodeLoading = false;
        }).catch(function (err) {
          _this11.queryCodeLoading = false;
          _this11.$message.error(err.message || '验证码发送失败，请稍后重试');
        });
      });
    },
    // 提交查询入驻
    submitQuery: function submitQuery() {
      var _this12 = this;
      this.$refs.queryFormRef.validate(function (valid) {
        if (valid) {
          _this12.queryLoading = true;
          getApplyQryApi(_this12.queryForm).then(function (res) {
            _this12.queryLoading = false;
            _this12.queryDialogVisible = false;

            // res 是响应对象，res.data 是实际数据
            var data = res && res.data ? res.data : res;
            if (data) {
              var apply_status = data.apply_status,
                apply_status_msg = data.apply_status_msg,
                pageUrl = data.pageUrl;

              // 显示状态消息
              if (apply_status_msg) {
                _this12.$message.info(apply_status_msg);
              }

              // 如果状态是04，显示跳转弹窗
              if (apply_status === '04' && pageUrl) {
                _this12.queryResultPageUrl = pageUrl;
                _this12.queryResultDialogVisible = true;
              }
            } else {
              _this12.$message.error('查询失败，未找到入驻信息');
            }
          }).catch(function (err) {
            _this12.queryLoading = false;
            _this12.$message.error(err.message || '查询失败，请稍后重试');
          });
        }
      });
    },
    // 跳转到入驻页面
    jumpToPageUrl: function jumpToPageUrl() {
      if (this.queryResultPageUrl) {
        window.open(this.queryResultPageUrl, '_blank');
        this.queryResultDialogVisible = false;
      }
    }
  }
};